import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Collapse } from 'antd';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import SeoHead from '../../components/common/SeoHead';
import LoadingScreen from '../../components/common/LoadingScreen';
import api from '../../services/api';

const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_URL || 'https://www.businessmateworkflow.in';

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [related, setRelated] = useState([]);
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/services/${slug}`)
      .then((res) => {
        setService(res.data.data);
        setRelated(res.data.relatedServices || []);
        setSeo(res.data.seo);
      })
      .catch((err) => {
        if (err.response?.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (notFound || !service) {
    return (
      <main>
        <Navbar />
        <div className="container text-center" style={{ padding: '100px 0' }}>
          <h1>Service Not Found</h1>
          <p>This service may have been renamed or is no longer available.</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>Back to Home</button>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main>
      <SeoHead seo={seo} />
      <Navbar />

      {/* HERO */}
      <section style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', padding: '20px 0', color: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span style={{ background: '#06b590', padding: '8px 18px', borderRadius: 30, fontSize: 14, fontWeight: 600, display: 'inline-block', marginBottom: 20 }}>
                Our Services
              </span>
              <h1 style={{ fontSize: 38, fontWeight: 700, marginBottom: 16,color:'#fff' }}>{service.h1 || service.service_name}</h1>
              <p style={{ fontSize: 17, opacity: 0.85 }}>{service.short_description}</p>
              {service.cta_text && service.cta_link && (
                <a href={service.cta_link} className="btn btn-lg" style={{ background: '#06b590', color: '#fff', marginTop: 20, display: 'inline-block', padding: '12px 28px', borderRadius: 6, textDecoration: 'none', fontWeight: 600 }}>
                  {service.cta_text}
                </a>
              )}
            </div>
            {service.banner_image && (
              <div className="col-lg-6">
                <img
                  src={`${UPLOADS_BASE}/${service.banner_image}`}
                  alt={service.banner_image_alt || service.service_name}
                  style={{ width: '100%', borderRadius: 12 }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* CONTENT */}
      <section style={{ padding: '20px 50px' }}>
        <div>
          <div className="row">
            <div className="col-lg-12">
              <div
                style={{ fontSize: 16, lineHeight: 1.8, color: '#334155' }}
                dangerouslySetInnerHTML={{ __html: service.full_description || '' }}
              />

              {service.faqs && service.faqs.length > 0 && (
                <div style={{ marginTop: 48 }}>
                  <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 20 }}>Frequently Asked Questions</h2>
                  <Collapse
                    items={service.faqs.map((faq, idx) => ({
                      key: idx,
                      label: faq.question,
                      children: <p>{faq.answer}</p>
                    }))}
                  />
                </div>
              )}
            </div>

            <div className="col-lg-4">
              {related.length > 0 && (
                <div style={{ background: '#f8fafc', borderRadius: 12, padding: 24 }}>
                  <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Related Services</h3>
                  {related.map((r) => (
                    <Link
                      key={r.id}
                      to={`/${r.slug}`}
                      style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #e2e8f0', color: '#0f172a', textDecoration: 'none', fontWeight: 500 }}
                    >
                      {r.service_name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default ServiceDetail;
